export default "__VITE_ASSET__Gjwzw_XL__"